import { Award } from 'lucide-react';
import { awards } from '../../data/homeData';

const AwardsSection = () => (
  <section className="py-16 md:py-24 bg-slate-50" data-testid="awards-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary mb-4">
          Awards & Accomplishments
        </h2>
        <p className="text-lg text-slate-600 max-w-2xl mx-auto">
          Recognized excellence in urological care.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {awards.map((award, index) => (
          <div
            key={index}
            className="bg-white rounded-xl p-6 text-center border border-slate-100"
            data-testid={`award-${index}`}
          >
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-black/10 rounded-full">
              <Award className="h-8 w-8 text-primary" />
            </div>
            <h3 className="font-heading text-lg font-semibold text-primary mb-1">{award.title}</h3>
            <p className="text-slate-600 text-sm">{award.org}</p>
            <p className="text-brand font-medium text-sm mt-2">{award.year}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default AwardsSection;
